import { cloneDeep } from 'lodash';
import { AnyAction } from 'redux';
import { LinkContextModel } from '../models/linkContextModel';
import actionTypes from '../types/linkContextTypes';

const initialState: LinkContextModel = {
  fileList: {},
  authModes: [],
  abhaFormData: {},
  reloadLinkedRecordsList: 0,
  linkedRecordFilters: {},
  documentList: [],
  isAuthFetchError: false,
};

const reducer = (
  state: any = cloneDeep(initialState),
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.UPDATE_FILE_LIST:
      return {
        ...state,
        fileList: action.payload,
      };
    case actionTypes.UPDATE_ABHA_FORM_DATA:
      return {
        ...state,
        abhaFormData: action.payload,
      };
    case actionTypes.SET_AUTH_MODES:
      return {
        ...state,
        authModes: action.payload,
      };
    case actionTypes.SET_DOC_LIST_FOR_ABHA:
      return {
        ...state,
        documentList: action.payload,
      };
    case actionTypes.RESET_LINK_RECORDS:
      return cloneDeep(initialState);
    case actionTypes.RELOAD_LINKED_RECORDS_LIST:
      return {
        ...state,
        reloadLinkedRecordsList: state.reloadLinkedRecordsList + 1,
      };
    case actionTypes.APPLY_LINKED_RECORDS_FILTER:
      return {
        ...state,
        linkedRecordFilters: {
          ...state.linkedRecordFilters,
          ...action.payload,
        },
      };
    case actionTypes.SET_AUTH_FETCH_MODES_ERROR:
      return {
        ...state,
        isAuthFetchError: action.payload,
      };
    default: return state;
  }
};

export { reducer as linkContextReducer };
